// BUILD-042 (Oct 17 17:22 appendix) - one date control for values HR enters (assignment time or fixed text).
// HR can TYPE the date (slashes are added as they type) or pick it on a calendar. The format is always shown as MM/DD/YYYY, and a date that is
// not a real calendar date (13/45/2026, 02/30/2026, 02/29/2027) is refused in plain words before anything is saved or assigned.
//
// The value is kept as the exact text "MM/DD/YYYY". The calendar returns YYYY-MM-DD and is converted by splitting the text - never through a
// Date object - so there is no time zone or daylight-saving shift: the characters HR sees are the characters stored and printed.
// This is for HR-entered values only. It is NOT the "Date signed" field and writes nothing to the employee record or payroll.
import { DATE_US_EXAMPLE, isRealUsDate, isoToUs, maskUsDate, usToIso } from './formFieldsModel';

export function dateEntryProblem(value: string): string | null {
  if (!value) return null;
  if (value.length < 10) return `Finish the date as MM/DD/YYYY, for example ${DATE_US_EXAMPLE}.`;
  return isRealUsDate(value) ? null : `That is not a real calendar date. Use MM/DD/YYYY, for example ${DATE_US_EXAMPLE}.`;
}

export function DateEntry({
  id, value, onChange, testId, describedBy,
}: {
  id: string;
  value: string;
  onChange: (next: string) => void;
  testId: string;
  describedBy?: string;
}) {
  const problem = dateEntryProblem(value);
  const helpId = `${id}-date-help`;
  return (
    <div className="flex flex-col gap-0.5" data-testid={`${testId}-date`}>
      <div className="flex items-center gap-1.5">
        <input
          id={id} value={value} inputMode="numeric" autoComplete="off" spellCheck={false} maxLength={10} placeholder="MM/DD/YYYY"
          aria-invalid={problem ? true : undefined} aria-describedby={`${helpId}${describedBy ? ` ${describedBy}` : ''}`}
          onChange={(e) => onChange(maskUsDate(e.target.value))}
          className={`border rounded px-2 py-1 text-xs w-32 font-mono ${problem ? 'border-red-400' : 'border-gray-300'}`} data-testid={testId}
        />
        <input
          type="date" value={usToIso(value)} min="1900-01-01" max="2100-12-31" aria-label="Pick the date on a calendar"
          onChange={(e) => onChange(isoToUs(e.target.value))}
          className="border border-gray-300 rounded px-1.5 py-1 text-xs" data-testid={`${testId}-calendar`}
        />
      </div>
      <span id={helpId} className={`text-[11px] ${problem ? 'text-red-700' : 'text-gray-500'}`} role={problem ? 'alert' : undefined} data-testid={`${testId}-date-help`}>
        {problem ?? `Format: MM/DD/YYYY (month / day / year), for example ${DATE_US_EXAMPLE}.`}
      </span>
    </div>
  );
}
